import { render, staticRenderFns } from "./SearchPostcode.vue?vue&type=template&id=5ce1469c&scoped=true"
import script from "./SearchPostcode.vue?vue&type=script&lang=ts"
export * from "./SearchPostcode.vue?vue&type=script&lang=ts"
import style0 from "./SearchPostcode.scss?vue&type=style&index=0&id=5ce1469c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce1469c",
  null
  
)

export default component.exports